import { useEffect } from 'react';

const SITE_URL = 'https://catoakay.com';

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Lightweight, dependency-free per-route SEO manager.
 * Updates <title>, meta description/keywords, canonical, Open Graph,
 * Twitter card and a JSON-LD block for the currently mounted page.
 *
 * The static <head> in public/index.html carries the umbrella brand
 * defaults (used by crawlers that don't execute JS, e.g. link-preview
 * bots); this component refines it per-route for full browsers and
 * JS-rendering crawlers.
 */
function Seo({ title, description, path = '/', image, jsonLd }) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const ogImage = image ? `${SITE_URL}${image}` : `${SITE_URL}/pic/cato1.jpg`;

    if (title) document.title = title;
    setMeta('name', 'description', description);
    setLink('canonical', url);

    setMeta('property', 'og:url', url);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:image', ogImage);

    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', ogImage);

    let script = document.getElementById('route-jsonld');
    if (jsonLd) {
      if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = 'route-jsonld';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, image, jsonLd]);

  return null;
}

export default Seo;

